module.exports = __webpack_public_path__ + "static/media/teamProfileS.5b75d3b7.png";